import type { I18nPrefix } from '../../i18n/prefix';

const PAGE = 'features:partner_portal.pages.partner_overview_page' satisfies I18nPrefix;

export const PARTNER_PORTAL_I18N = { page: PAGE } as const;

export const PARTNER_PORTAL_URLS = Object.freeze({
  portal: 'https://partners.sparklayer.io/',
  leads: 'https://partners.sparklayer.io/leads?tab=all-leads',
  partnerRoom: 'https://partners.sparklayer.io/partner-room',
});
